export default __webpack_public_path__ + "static/media/open-eps.f5b7f10d.png";